import type { Breakpoints } from './types';

const breakpoints: Breakpoints = {
  xs: '0px',
  sm: '768px',
  md: '992px',
  lg: '1440px',
  xl: '1920px',
};

export { breakpoints };
